import {META_FETCHED} from "./types";
import firebase, {db} from "../firebase/firebase";
import createEntityReducer from "../reducers/entity";
import reducerRegistry from "../reducers/reducerRegistry";
import {createSchemas} from "../utils/schemas";
import {setMeta} from "../utils/metaUtil";

export const metaFetched = (data) => ({
    type: META_FETCHED,
    data
});
const registerReducers = data => {
    Object.keys(data.entities).map(e=>{
        reducerRegistry.register(e, createEntityReducer(e));
    });
};
export const fetchMeta = (projectId) => dispatch =>
    db.collection("project").where(firebase.firestore.FieldPath.documentId(), "==", projectId).get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            // after we get back our meta data, we want to register the appropriate reducers/entities
            registerReducers(doc.data());
            dispatch(metaFetched(doc.data()));
            createSchemas(doc.data());

        });
    });




// WEBPACK FOOTER //
// ./src/actions/meta.js